var context = typeof window !== 'undefined' ? window : global;
var localStorage = context.localStorage;
/** 
 * Checks if localStorage is supported.
 * @constant
 * @type {Boolean}
 */

var isSupported = !!localStorage;
/**
 * List of all reducer names that are synced.
 * @type {string[]}
 */

var syncedReducers = [];
/**
 * Used action types.
 * @readonly
 * @enum {string}
 */

export var ActionTypes = {
  UPDATE: '@@redux-sync-reducer/UPDATE'
  /**
   * Get the key used in localStorage.
   */

};

function getKeyName(name) {
  return "@@redux-sync-reducer/".concat(name);
}
/**
 * Sync data between tabs.
 * @param {string} name 
 * @param {object} prev
 * @param {object} next 
 */


function sync(name, prev, next) {
  if (isSupported && prev !== next) {
    localStorage.setItem(getKeyName(name), JSON.stringify(next));
  }

  return next;
}
/**
 * High level reducer to wrap reducers to sync the state between tabs.
 * @param {function} reducer 
 * @param {object} config 
 */


export function syncedReducer(reducer) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var name = config.name || reducer.toString();
  syncedReducers.push(name);
  return function (state) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    for (var _len = arguments.length, slices = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      slices[_key - 2] = arguments[_key];
    }

    if (action.type === ActionTypes.UPDATE && action.name === name) {
      return config.skipReducer ? action.payload : reducer.apply(void 0, [action.payload, action].concat(slices));
    }

    if (state === undefined && !config.skipLoading) {
      if (isSupported) {
        var initialState = JSON.parse(localStorage.getItem(getKeyName(name))); // we don't need to sync here, because other reducers also fallback

        return reducer.apply(void 0, [initialState || state, action].concat(slices));
      }
    }

    return sync(name, state, reducer.apply(void 0, [state, action].concat(slices)));
  };
}
/**
 * Registers storage event listener and dispatches actions when the state gets changed in different tabs.
 */

export var syncMiddleware = function syncMiddleware(store) {
  isSupported && context.addEventListener('storage', function (e) {
    syncedReducers.some(function (name) {
      if (e.key === getKeyName(name)) {
        // don't use e.newValue because it doesn't work in IE
        var payload = JSON.parse(localStorage.getItem(e.key));
        store.dispatch({
          type: ActionTypes.UPDATE,
          payload: payload,
          name: name
        });
        return true;
      }

      return false;
    });
  });
  return function (next) {
    return function (action) {
      return next(action);
    };
  };
};